import styled from 'styled-components';
import { type ConfiguratorDepositDisplayProps } from '../../context';

type BasedOnSummaryProps = { isSummaryContent: boolean };
const getBasedOnSummary =
    (forSummary: string, forNotSummary: string) =>
    ({ isSummaryContent }: BasedOnSummaryProps) =>
        isSummaryContent ? forSummary : forNotSummary;

export const DepositContainer = styled.div<BasedOnSummaryProps>`
    margin-top: 1.875rem;
    font-size: 16px;
    height: 54px;
    padding: 8px 16px;
    background: ${getBasedOnSummary('#eeeff2;', '#ffffff')};
    border-radius: 4px;
    outline: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 20px;
    font-weight: bold;
`;
const DepositDisplay = ({ label, value, isSummaryContent }: ConfiguratorDepositDisplayProps) => (
    <DepositContainer isSummaryContent={isSummaryContent}>
        <div>{label}</div>
        <div>{value}</div>
    </DepositContainer>
);

export default DepositDisplay;
